import React from 'react';

import ArtifactForm, {
  ArtifactFormComponentProps,
} from '@/features/artifacts/components/ArtifactForm';
import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';

const AgendamentoFormDefault: ArtifactFormOverrides = [
  {
    name: 'reasonCode',
    label: 'Motivo',
    attrs: { autoFocus: true },
    containerStyle: { flex: '0 1 100%' },
  },
  { name: 'startDate', label: 'Data' },
  { name: 'startTime', label: 'Horário' },
  {
    name: 'description',
    label: 'Observação',
    containerStyle: { flex: '0 1 100%' },
  },
];

export type FormAgendamentoProps = ArtifactFormComponentProps;

const FormAgendamento: React.FC<FormAgendamentoProps> = ({
  resource,
  onSubmit,
  onCancel,
  disabled = false,
  loading = false,
  readOnly = false,
}) => {
  const form = useArtifactFormConfig('agendamento', AgendamentoFormDefault);

  return (
    <ArtifactForm
      form={form}
      resource={resource}
      loading={loading}
      disabled={disabled}
      readOnly={readOnly}
      onResourceSubmit={onSubmit}
      onResourceSubmitCancel={onCancel}
    />
  );
};

export default FormAgendamento;
